import { Line } from '@react-three/drei'
import { formatForLabel } from 'pages/siteView/siteMap/communalMapStyling/FormatForLabel'
import { TilesetMapFeatureLabel } from 'pages/siteView/siteMap/tilesetMap/objects/TilesetMapFeatureLabel'
import polylabel from 'polylabel'
import React, { ReactNode, useState } from 'react'
import { SiteFeaturePolygon } from 'types'

import { useTilesetMapFeatureHelpers } from './useTilesetMapFeatureHelpers'

export const TilesetMapFeaturePolygon3D: React.FC<{
  polygon: SiteFeaturePolygon
  color: string
  visible: boolean
  extraLabelDisplay?: ReactNode
}> = ({ polygon, color, visible, extraLabelDisplay }) => {
  const [showName, setShowName] = useState(false)
  const { convertCartographicToPosition } = useTilesetMapFeatureHelpers()
  const xyzs = React.useMemo(() => {
    return polygon.coordinates.map((coordinate) =>
      convertCartographicToPosition(coordinate)
    )
  }, [convertCartographicToPosition, polygon.coordinates])

  const labelPostion = React.useMemo(() => {
    const coords = polygon.coordinates.map((val) => [val.lat, val.lon])
    const height = polygon.coordinates.reduce(
      (prevVal, val) => Math.max(prevVal, val.height),
      -Infinity
    )

    const label = polylabel([coords], 0.000000001)
    return convertCartographicToPosition({
      lat: label[0],
      lon: label[1],
      height: height,
    })
  }, [polygon.coordinates, convertCartographicToPosition])

  return (
    <>
      <Line
        name={polygon.id}
        userData={{ siteFeature: polygon }}
        points={[...xyzs, xyzs[0]]}
        lineWidth={5}
        color={color}
        polygonOffset={true}
        polygonOffsetFactor={-5}
        polygonOffsetUnits={-5}
        onPointerEnter={() => setShowName(true)}
        onPointerLeave={() => setShowName(false)}
        visible={visible}
      />
      {!polygon.name ? null : (
        <TilesetMapFeatureLabel
          body={formatForLabel(polygon.name, extraLabelDisplay)}
          hovered={showName}
          position={labelPostion}
          visible={visible}
        />
      )}
    </>
  )
}
